// extracted by mini-css-extract-plugin
export var button = "_gz-4";
export var hasDarkBackground = "_gz-7";
export var hasLightBackground = "_gz-6";
export var iconWrapper = "_gz-0";
export var large = "_gz-2";
export var medium = "_gz-1";
export var small = "_gz-5";
export var xsmall = "_gz-3";